import React from 'react';
import { motion } from 'framer-motion';
import { HeartIcon, UsersIcon, ShieldCheckIcon, SparklesIcon, MessageCircleIcon, CheckCircleIcon } from 'lucide-react';
export function SymbisCoaching() {
  return <main className="bg-[#F5F2ED] min-h-screen" data-id="element-387">
      <section className="py-20 bg-[#B8860B] text-white" data-id="element-388">
        <div className="container mx-auto px-4 text-center" data-id="element-389">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-5xl font-serif mb-6" data-id="element-390">
            SYMBIS Marriage Coaching
          </motion.h1>
          <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed" data-id="element-391">
            Saving Your Marriage Before It Starts. Relationship restoration and
            strengthening for couples at every stage.
          </p>
        </div>
      </section>

      <section className="py-20" data-id="element-392">
        <div className="container mx-auto px-4" data-id="element-393">
          <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-394">
            <div data-id="element-395">
              <h2 className="text-4xl font-serif text-[#1B4332] mb-8" data-id="element-396">
                Rebuild Your Connection
              </h2>
              <p className="text-lg text-[#1A374D]/80 mb-8 leading-relaxed" data-id="element-397">
                As a Certified SYMBIS Facilitator and Couples Repair Specialist
                with 8 years of experience, we help couples navigate the
                complexities of partnership with evidence-based tools and
                compassionate guidance.
              </p>
              <div className="space-y-4" data-id="element-398">
                {['Pre-marital Preparation', 'Marriage Restoration & Repair', 'Communication Skill Building', 'Conflict Resolution Strategies', 'Deepening Emotional Intimacy', 'Rediscovering Shared Purpose'].map(item => <div key={item} className="flex items-center gap-3" data-id="element-399">
                    <CheckCircleIcon className="text-[#B8860B]" size={20} data-id="element-400" />
                    <span className="font-medium text-[#1A374D]" data-id="element-401">{item}</span>
                  </div>)}
              </div>
            </div>
            <div className="relative" data-id="element-402">
              <div className="aspect-[4/3] rounded-3xl overflow-hidden shadow-2xl" data-id="element-403">
                <img src="https://images.unsplash.com/photo-1516589174184-c685266d430c?auto=format&fit=crop&q=80&w=1000" alt="Couple communicating" className="w-full h-full object-cover" data-id="element-404" />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-white p-8 rounded-2xl shadow-xl border border-[#B8860B]/20 max-w-xs" data-id="element-405">
                <HeartIcon className="text-[#B8860B] mb-4" size={32} data-id="element-406" />
                <p className="text-[#1B4332] font-serif italic text-lg" data-id="element-407">
                  "Restoring the heart of your home."
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white" data-id="element-408">
        <div className="container mx-auto px-4 text-center" data-id="element-409">
          <h2 className="text-3xl font-serif text-[#1B4332] mb-12" data-id="element-410">
            The SYMBIS Advantage
          </h2>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-411">
            <div className="p-8 rounded-2xl bg-[#F5F2ED]" data-id="element-412">
              <MessageCircleIcon className="mx-auto text-[#B8860B] mb-6" size={40} data-id="element-413" />
              <h3 className="text-xl font-bold text-[#1B4332] mb-4" data-id="element-414">
                Deep Insights
              </h3>
              <p className="text-[#1A374D]/70" data-id="element-415">
                Comprehensive assessments that reveal the underlying dynamics of
                your relationship.
              </p>
            </div>
            <div className="p-8 rounded-2xl bg-[#F5F2ED]" data-id="element-416">
              <UsersIcon className="mx-auto text-[#B8860B] mb-6" size={40} data-id="element-417" />
              <h3 className="text-xl font-bold text-[#1B4332] mb-4" data-id="element-418">
                Expert Facilitation
              </h3>
              <p className="text-[#1A374D]/70" data-id="element-419">
                8 years of specialized experience in marriage repair and
                relationship restoration.
              </p>
            </div>
            <div className="p-8 rounded-2xl bg-[#F5F2ED]" data-id="element-420">
              <SparklesIcon className="mx-auto text-[#B8860B] mb-6" size={40} data-id="element-421" />
              <h3 className="text-xl font-bold text-[#1B4332] mb-4" data-id="element-422">
                Lasting Change
              </h3>
              <p className="text-[#1A374D]/70" data-id="element-423">
                Practical tools and strategies designed to sustain a healthy,
                purpose-driven marriage.
              </p>
            </div>
          </div>
          <button className="mt-16 px-12 py-4 bg-[#B8860B] text-white font-bold rounded-full hover:bg-[#966d09] transition-all shadow-lg text-lg" data-id="element-424">
            Start Your Relationship Assessment
          </button>
        </div>
      </section>
    </main>;
}